import { PosServiceProvider } from './../../providers/pos-service/pos-service';
import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the PosRunningPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pos-running',
  templateUrl: 'pos-running.html',
})
export class PosRunningPage {
  dash: {};
  dashTimer: {};
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';
  totalRec = 0;
  totalAmt = 0;
  use_timer_schedule = false;
  server_date = new Date();

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private posservice: PosServiceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
      this.name = info.name;
      this.username = info.username;
      this.serverlocation = info.serverlocation;
      this.userid = info.userid;
      this.token = info.token;
      if(this.global.use_timer_schedule == 1) {
        this.use_timer_schedule = true;
      }
      // this.use_timer_schedule = this.global.use_timer_schedule;// (info.use_timer_schedule == 1);
      console.log('use timer sch ' , this.use_timer_schedule , ' global: ' ,this.global.use_timer_schedule);
       
      this.loadData();      
      this.getDateServer();

      if(this.use_timer_schedule) {
        //Running timer for remaining time
        setInterval(() => {
          this.calculateTimer();
        }, 30000);  //Every 0.5 minutes: 30000
      }
      
  }

  public calculateTimer() {
    this.getDateServer();
    //console.log('On timer');
    let m = 0;
    for(let key in this.dashTimer){
      let j = new Date(this.dashTimer[m].onTimerEnd);
      let diffInMilliSecs:number  = (new Date(j).getTime() - new Date(this.server_date).getTime()) ;
        let diffinMins: number = diffInMilliSecs / 1000/60;
        let hours = Math.floor(diffinMins / 60);
        let minutes = Math.floor(diffinMins % 60);
        if(this.dashTimer[m].Remaining !== "00:00") {
          this.dashTimer[m].Remaining =  ("00" + hours).slice(-2) + ':' + ("00" + minutes).slice(-2);
        }
        //console.log('Hour: ' + ("00" + hours).slice(-2) + ' minutes: ' + ("00" + minutes).slice(-2));

        m++;
    }
  }
  public getDateServer() {
    this.posservice.getDateServer(this.userid, this.token, this.serverlocation)
      .then(data => {      
        this.server_date = data['message'];
      });
  }
  public loadData() {
    this.showLoading();
    console.log("use timer ", this.use_timer_schedule );
    if(this.use_timer_schedule) {
      console.log('load timer');
      
      this.posservice.loadPOSRunningTimer(this.userid, this.token, this.serverlocation)
      .then(data => {
        this.dashTimer = data;

        let myArr = [];
        myArr.push(this.dashTimer);
        let sortedBuilds = myArr.sort((n1, n2) => {
          return this.naturalCompare(n1.name, n2.name)
        })
        
        //Sorting myArr
        this.dashTimer = sortedBuilds[0];

        //Original below
        //Edited on #20240418
        // let sortedBuilds = this.dashTimer.sort((n1, n2) => {
        //   return this.naturalCompare(n1.name, n2.name)
        // })


        console.log(this.dashTimer);
        this.totalAmt = this.totalamttimer();
        this.loading.dismiss();
      });
    } else {
      console.log('Load post running');
      
      this.posservice.loadPOSRunning(this.userid, this.token, this.serverlocation, this.global.ICNO)
      .then(data => {
        this.dash = data;
        this.totalAmt = this.totalamt();
        //console.log(this.dash);
        this.loading.dismiss();
      });
    }
    

  }

  naturalCompare(a, b) {
    var ax = [], bx = [];
 
    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });
 
    while (ax.length && bx.length) {
      var an = ax.shift();
      var bn = bx.shift();
      var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
      if (nn) return nn;
    }
 
    return ax.length - bx.length;
 }

  totalamt() {
    let total = 0;
    let m =0;
    for(let key in this.dash){
      //console.log('Dash '+m+': '+this.dash[m].TotalNet);
      let j = this.dash[m].TotalNet;
      total += Number(j.replace(/,/g, ''));
      //console.log('Dash Total '+m+': '+total);
      m++;
    }
    this.totalRec = m;
    return total;
  }
  totalamttimer() {
    let total = 0;
    let m =0;
    for(let key in this.dashTimer){
      //console.log('Dash '+m+': '+this.dashTimer[m].Total);
      let j = this.dashTimer[m].Total;
      total += Number(j.replace(/,/g, ''));
      //console.log('Dash Total '+m+': '+total);
      m++;
    }
    this.totalRec = m;
    return total;
  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.getDateServer();
    this.loadData();
    setTimeout(() => {      
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad PosRunningPage');
  }
  ionViewDidEnter() {
    this.getDateServer();
  }

}



// WEBPACK FOOTER //
// ./src/pages/pos-running/pos-running.ts